import { IMatchReportsDetail, MatchReportsTypings, PlayerTypings, MatchTypings } from "@sky-it-livedata/livedata-sports-design-system";
import { MatchReportsDetailsQuery } from "../types";
import { WidgetError, ErrorName } from "../../../utils/errors";
import { isValidMatchReportsDetails } from "./typeguards";

export default (obj: MatchReportsDetailsQuery): IMatchReportsDetail => {
    
    if (isValidMatchReportsDetails(obj)) {

        const { reports, reportsHomepageUrl } = obj.data.getReportDetails;

        const matchDayList = reports?.map((report) => ({
            ...report,
            away: report?.away  as  IMatchReportsDetail["matchDayList"][number]["away"] ,
            home: report?.home as IMatchReportsDetail["matchDayList"][number]["home"],
            date: report?.date || '',
            referees: report?.referees?.filter(Boolean).map((referee) => {
                return {
                    fullname: referee?.fullname,
                    topPlayer: referee?.topPlayer,
                    id: referee?.id,
                    vote: referee?.vote,
                }
            }) as PlayerTypings.IReferee[] | undefined,
            reportStatus: report?.reportStatus as MatchReportsTypings.ReportStatus,
            status: report?.status as MatchTypings.MatchStatusType,
        }));

        return {
            matchDayList: matchDayList || [],
            reportsHomepageUrl: reportsHomepageUrl || undefined,
          };
    } else {
        throw new WidgetError<ErrorName>({
          name: "NO_VALID_DATA",
          message: "Invalid transformer input, Error in MatchReportsDetailsQuery object",
          data: obj,
        });
    }
};